import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d764f25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "merge-customer-preview" }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-2 flex-wrap"
}

import { ref, withDefaults, watch } from "vue";
import { PreviewMergedCustomerFieldNames } from "@/clinic/typings/enums/customer";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import TimeUtils from "@/clinic/utils/time-utils";
import { JP_DATE_FORMAT, JP_DATE_TIME_FORMAT, TIME_FORMAT } from "@/clinic/typings/constants/booking";
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";

type IProps = {
  data: any;
  loading: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'preview',
  props: {
    data: { default: {} },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { data: any, loading: boolean };

const basicColumns = [
  { field: "label", header: "情報", class: "col-4" },
  { field: "value", header: "内容", class: "col-8" },
];

const bookingColumns = [
  { field: "id", header: "予約ID", class: "col-2" },
  { field: "customer_code", header: "カルテNo.", class: "col-2" },
  { field: "time", header: "予約日時", class: "col-6" },
  { field: "status", header: "ステータス", class: "col-2" },
];

const taggedLabels = {
  [PreviewMergedCustomerFieldNames.system_tags]: { bgColor: "#b5dbff" },
  [PreviewMergedCustomerFieldNames.partner_tags]: { bgColor: "#cffcaf" },
  [PreviewMergedCustomerFieldNames.penultimate_booking_services]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.age]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.visit_status]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.total_visits]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.total_visits_in_current_month]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.latest_booking_services]: { bgColor: "#ffab12" },
  [PreviewMergedCustomerFieldNames.booking_services_history]: { bgColor: "#f0e68c" },
};



const basicData = ref<any[]>([]);
const bookingData = ref<any[]>([]);

const findCustomerStatus = (value: string): string | undefined => {
  return Object.keys(CustomerStatusesConstants).find(
    key => CustomerStatusesConstants[key as keyof typeof CustomerStatusesConstants] === value
  );
};

const buildFirstTimeVisit = (firstTimeVisit: any) => {
  if (!firstTimeVisit) return "";
  const firstTimeVisitText = TimeUtils.formatJpDateTime(firstTimeVisit, JP_DATE_FORMAT);
  const timeSinceFirstVisit = props.data.find(item => item.type == "time_since_first_visit")?.value || [0, 0];
  const [years, months] = timeSinceFirstVisit;
  let timeSinceFirstVisitText = "";
  timeSinceFirstVisitText += years > 0 ? `${years}年` : "";
  timeSinceFirstVisitText += months > 0 ? `${months}ヶ` : "";

  return `${firstTimeVisitText} (${timeSinceFirstVisitText}月経過)`;
};
const buildLastTimeVisit = (latestTimeVisit: any) => {
  if (!latestTimeVisit) return "";
  const lastTimeVisitText = TimeUtils.formatJpDateTime(latestTimeVisit, JP_DATE_FORMAT);
  const timeSinceLastVisit = props.data.find(item => item.type == "days_since_last_visit").value;

  return `${lastTimeVisitText} (${timeSinceLastVisit}日経過)`;
};
const formatBasicData = (data: any) => {
  return data.map((item: any) => {
    if (item.label == PreviewMergedCustomerFieldNames.first_time_visit) item.value = buildFirstTimeVisit(item.value);
    if (item.label == PreviewMergedCustomerFieldNames.latest_time_visit) item.value = buildLastTimeVisit(item.value);
    if (item.label == PreviewMergedCustomerFieldNames.number_of_visit) item.value = item.value + "回";
    if (item.label == PreviewMergedCustomerFieldNames.visit_cycle_in_one_year)
      item.value = "平均" + (item.value || 0) + "日";
    if (item.label == PreviewMergedCustomerFieldNames.birthday)
      item.value = TimeUtils.formatJpDateTime(item.value, JP_DATE_FORMAT);
    return item;
  });
};
const formatBookingData = (data: any) => {
  return data.map((item: any) => {
    item["time"] =
      TimeUtils.formatJpDateTime(item.start_time, JP_DATE_TIME_FORMAT) +
      " - " +
      TimeUtils.formatJpDateTime(item.end_time, TIME_FORMAT);
    return item;
  });
};
watch(
  () => props.data,
  newData => {
    basicData.value = newData.filter((item: any) => Object.keys(PreviewMergedCustomerFieldNames).includes(item.type));
    basicData.value = formatBasicData(basicData.value);
    bookingData.value = newData.find((item: any) => item.type == "bookings")?.value || [];
    bookingData.value = formatBookingData(bookingData.value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TabView), null, {
      default: _withCtx(() => [
        _createVNode(_unref(TabPanel), { header: "基本情報" }, {
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              lazy: "",
              loading: __props.loading,
              value: basicData.value,
              tableClass: "w-full",
              scrollable: "",
              scrollHeight: "flex"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(basicColumns, (col) => {
                  return _createVNode(_component_Column, {
                    key: col.field,
                    field: col.field,
                    header: col.header,
                    class: _normalizeClass(col.class)
                  }, {
                    body: _withCtx(({ data, field }) => [
                      (field == 'value')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (Object.keys(taggedLabels).includes(data.label))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  (data[field])
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([data[field]].flat(), (tag) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: tag,
                                          class: "border-round-2xl px-2 py-1",
                                          style: _normalizeStyle({ backgroundColor: taggedLabels[data.label].bgColor })
                                        }, _toDisplayString(tag), 5))
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ]))
                              : (data.label == _unref(PreviewMergedCustomerFieldNames).customer_status)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["customer-status border-round-xl px-2", findCustomerStatus(data[field])])
                                  }, _toDisplayString(data[field]), 3))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(data[field]), 1)
                                  ], 64))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(data[field]), 1)
                          ], 64))
                    ]),
                    _: 2
                  }, 1032, ["field", "header", "class"])
                }), 64))
              ]),
              _: 1
            }, 8, ["loading", "value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "予約情報" }, {
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              lazy: "",
              loading: __props.loading,
              value: bookingData.value,
              tableClass: "w-full",
              scrollable: "",
              scrollHeight: "flex"
            }, {
              empty: _withCtx(() => [
                _createTextVNode("データがありません")
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bookingColumns, (col) => {
                  return _createVNode(_component_Column, {
                    key: col.field,
                    field: col.field,
                    header: col.header,
                    class: _normalizeClass(col.class)
                  }, null, 8, ["field", "header", "class"])
                }), 64))
              ]),
              _: 1
            }, 8, ["loading", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})